<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxStatusCell from "./_modules/inbox-status-cell"
  import { cellText, rowStatusDetail, rowStatusHint, rowStatusLabel } from "./_logic/helpers"

  let props: InboxWorkflowCellProps = $props()
</script>

<InboxStatusCell
  label={props.column.id === "status" ? rowStatusLabel(props) : cellText(props)}
  detail={props.column.id === "status" ? rowStatusDetail(props) : null}
  hint={props.column.id === "status" ? rowStatusHint(props) : null}
  disabled={props.disabled}
/>
